import { createAction } from 'redux-actions';
import * as types from './constants';

export const uploadFileRequest = createAction(types.UPLOAD_FILE_REQUEST);
export const uploadFileSuccess = createAction(types.UPLOAD_FILE_SUCCESS);
export const uploadFileFailure = createAction(types.UPLOAD_FILE_FAILURE);

export const createXMLRequest = createAction(types.CREATE_XML_REQUEST);
export const createXMLSuccess = createAction(types.CREATE_XML_SUCCESS);
export const createXMLFailure = createAction(types.CREATE_XML_FAILURE);

export const uploadActionRequest = createAction(types.UPLOAD_ACTION_REQUEST);
export const uploadActionSuccess = createAction(types.UPLOAD_ACTION_SUCCESS);
export const uploadActionFailure = createAction(types.UPLOAD_ACTION_FAILURE);

export const setSelectedEquipment = createAction(types.SET_SELECTED_EQUIPMENT);
